// Body and response of PUT /roles/{roleId}/permissions.
export interface RolePermissions {
    moduleIds: string[];
    permissions: string[];
}

// Response of GET /roles/{roleId}/permissions.
export interface RolePermissionsResponse extends RolePermissions {
    roleId: string;
    roleName: string;
    superAdmin: boolean;
}

export const permissionKey = (moduleId: string, operationId: string): string => `${moduleId}-${operationId}`;
